// errori.ts — raccoglie gli errori dell'app e li manda al server (pannello → Errori dell'app).
// Al massimo ERRORI_MAX_PER_SESSIONE per apertura, senza doppioni: mai una valanga di richieste.
import i18n from "i18next";
import { ERRORI_MAX_PER_SESSIONE, PIATTAFORMA, VERSIONE_APP } from "../costanti.ts";
import { richiesta } from "./api.ts";

const inviati = new Set<string>();
const MESSAGGIO_MAX = 2000;
const STACK_MAX = 8000;
const PERCORSO_MAX = 500;

export function segnalaErrore(errore: unknown): void {
  if (inviati.size >= ERRORI_MAX_PER_SESSIONE) return;
  const e = errore instanceof Error ? errore : new Error(String(errore));
  const chiave = `${e.name}:${e.message}`;
  if (inviati.has(chiave)) return;
  inviati.add(chiave);
  void richiesta("/api/v1/errori-client", {
    metodo: "POST",
    corpo: {
      piattaforma: PIATTAFORMA,
      versione: VERSIONE_APP,
      lingua: i18n.language?.slice(0, 20),
      messaggio: `${e.name}: ${e.message}`.slice(0, MESSAGGIO_MAX),
      stack: e.stack?.slice(0, STACK_MAX),
      percorso: window.location.pathname.slice(0, PERCORSO_MAX),
    },
  }).catch(() => undefined);
}

export function raccogliErrori(): void {
  window.addEventListener("error", (ev) => segnalaErrore(ev.error ?? ev.message));
  window.addEventListener("unhandledrejection", (ev) => segnalaErrore(ev.reason));
}
